import React, { Component } from 'react'; //import React Component
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

export class Footer extends Component {
    render() {
        return(
            <footer>
                <hr className="footer-content-divider"/>
                <div className="footer-content">
                    <Container className="footer-background">
                        <Row className="main-footer mt-4">
                            <Col xs={12} md={5}  className="footer-links"> 
                                <Row>
                                    <h5 className="footer-title">ANIMAL CROSSING PASSPORT QUIZ</h5>
                                </Row>
                                <Row>
                                    <ul className="links">
                                        <li><a href="https://github.com/info340a-sp20/project-2-mtapham" target="_blank" rel="noopener noreferrer">Github</a></li>
                                    </ul>
                                </Row>
                            </Col>

                            <Col xs={12} md={7} className="developer-bio">
                                <Row>
                                    <h5 className="footer-title">DEVELOPERS</h5>
                                </Row>
                                <Row>
                                    <Col xs={12} md={6}>
                                        <Row className="dev-profile jacinda-profile" aria-label="Developer Bio of Jacinda">
                                            <Col xl={3}>
                                                <Row>
                                                    <a href="https://www.linkedin.com/in/jacinda-eng-6432a8171/" target="_blank" rel="noopener noreferrer">
                                                        <img src='https://scontent-sea1-1.xx.fbcdn.net/v/t1.0-1/p480x480/56887147_632788923835226_4699191879684587520_n.jpg?_nc_cat=103&_nc_sid=dbb9e7&_nc_ohc=4FZrFz5mV3UAX-l9Nlm&_nc_ht=scontent-sea1-1.xx&_nc_tp=6&oh=2adf1ae6090a5525cfacb106561605cd&oe=5EF85B2B' alt="Jacinda Eng"/>
                                                    </a>
                                                </Row>
                                            </Col>
                                            <Col xl={9} className="developer-info">
                                                <Row className="dev-name">
                                                    <p>Jacinda Eng</p>
                                                </Row>
                                                <Row>
                                                    <p>Informatics · Class of 2022</p>
                                                </Row>
                                            </Col>
                                            <Col/>
                                        </Row>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Row className="dev-profile michelle-profile" aria-label="Developer Bio of Michelle">
                                            <Col xl={3}>
                                                <Row>
                                                    <a href="https://www.linkedin.com/in/michelletapham/" target="_blank" rel="noopener noreferrer">
                                                        <img src='https://scontent-sea1-1.xx.fbcdn.net/v/t1.0-1/p480x480/99288995_2522223691372406_1166732040666611712_o.jpg?_nc_cat=104&_nc_sid=dbb9e7&_nc_ohc=7vtOOMv7GGYAX9UZ6xB&_nc_ht=scontent-sea1-1.xx&_nc_tp=6&oh=52a669a39110c6f61aeb6950949eca92&oe=5EF6DFBE' alt="Michelle Pham"/>
                                                    </a>
                                                </Row>
                                            </Col>
                                            <Col xl={9} className="developer-info">
                                                <Row className="dev-name">
                                                    <p>Michelle Pham</p>
                                                </Row>
                                                <Row>
                                                    <p>Informatics · Class of 2022</p>
                                                </Row>
                                            </Col>
                                            <Col/>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={12} md={6}>
                                        <Row className="dev-profile israel-profile" aria-label="Developer Bio of Israel">
                                            <Col xl={3}>
                                                <Row>
                                                    <a href="https://www.linkedin.com/in/israelsixto/" target="_blank" rel="noopener noreferrer">
                                                        <img src='https://scontent-sea1-1.xx.fbcdn.net/v/t1.0-9/89346417_2754521164643725_285373518525235200_o.jpg?_nc_cat=109&_nc_sid=85a577&_nc_ohc=dXH5H6WPucsAX8cZd7i&_nc_ht=scontent-sea1-1.xx&oh=51c9e31722847a01c3ef8789f4568a3c&oe=5EF73479' alt="Israel Sixto-Sanchez"/>
                                                    </a>
                                                </Row>
                                            </Col>
                                            <Col xl={9} className="developer-info">
                                                <Row className="dev-name">
                                                    <p>Israel Sixto-Sanchez</p>
                                                </Row>
                                                <Row>
                                                    <p>Informatics · Class of 2020</p>
                                                </Row>
                                            </Col>
                                            <Col/>
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row className="dev-profile cheryl-profile" aria-label="Developer Bio of Cheryl">
                                            <Col xl={3}>
                                            
                                                <Row>
                                                    <a href="https://www.linkedin.com/in/cheryl-wu-59baa8174/" target="_blank" rel="noopener noreferrer">
                                                        <img src='https://scontent-sea1-1.xx.fbcdn.net/v/t1.0-1/p480x480/96380658_3922128304580540_8616154409564372992_n.jpg?_nc_cat=101&_nc_sid=dbb9e7&_nc_ohc=9MFnZyoWCO8AX9aHWRI&_nc_ht=scontent-sea1-1.xx&_nc_tp=6&oh=5eba86dd20783296244ce32e0304c78f&oe=5EF6F557' alt="Cheryl Wu"/>
                                                    </a>
                                                </Row>
                                            </Col>
                                            <Col xl={9} className="developer-info">
                                                <Row className="dev-name">
                                                    <p>Cheryl Wu</p>
                                                </Row>
                                                <Row>
                                                    <p>Informatics · Class of 2022</p>
                                                </Row>
                                            </Col>
                                            <Col/>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <hr className="footer-credits-divider"/>
                        <Row className="footer-credits">
                            <Container>
                                <p>INFO340: Client Side Development ·&nbsp;
                                    <span>&copy; 2020 Jacinda Eng, Michelle Pham, Israel Sixto, Cheryl Wu</span>
                                </p>
                            </Container>
                        </Row>
                    </Container>
                </div>
            </footer>
        );
    }
}

export default Footer;